import typescriptLogo from "../skillIcons/typescript.png";
import react from "../skillIcons/react-logo.png";
import reduxLogo from "../skillIcons/redux-logo.jpg";
import tailwindLogo from "../skillIcons/tailwind.png";
import reactQuery from "../skillIcons/react-query.png";
import mui from "../skillIcons/mui.png";
import moyassar from "../skillIcons/moyasar-logo.png";
import postman from "../skillIcons/postman.png";
import json from "../skillIcons/json.png";
import chart from "../skillIcons/chart-js.png";
import nuxt from "../skillIcons/NuxtJS_Logo.png";
import pinia from "../skillIcons/Pinialogo.png";
import laravel from "../skillIcons/laravel.webp";

export const skills = [
  {
    title: "React",
    image: react,
    description: "react",
    level: "advance",
  },
  {
    title: "Nuxt",
    image: nuxt,
    description: "nuxt",
    level: "inter",
  },
  {
    title: "Redux Toolkit",
    image: reduxLogo,
    description: "redux",
    level: "advance",
  },

  {
    title: "Pinia",
    image: pinia,
    description: "pinia",
    level: "advance",
  },
  {
    title: "TypeScript",
    image: typescriptLogo,
    description: "typescript",
    level: "advance",
  },

  {
    title: "React Query",
    image: reactQuery,
    description: "react_query",
    level: "advance",
  },
  {
    title: "Laravel",
    image: laravel,
    description: "laravel_desc",
    level: "basic",
  },
  {
    title: "Tailwind",
    image: tailwindLogo,
    description: "tailwind",
    level: "advance",
  },
  {
    title: "Postman",
    image: postman,
    description: "postman",
    level: "advance",
  },
  {
    title: "Material UI",
    image: mui,
    description: "mui",
    level: "advance",
  },
  {
    title: "Moyasser",
    image: moyassar,
    description: "moyassar",
    level: "basic",
  },

  // {
  //   title: "JSON Data Handling",
  //   image: json,
  //   description: "json",
  //   level: "advance",
  // },

  {
    title: "Chart Js",
    image: chart,
    description: "chart",
    level: "advance",
  },
];
